const { createAction } = require('../helpers')
const {
  // For Admin Panel
  GET_PRESCRIPTION_LIST,
  GET_PRESCRIPTION_LIST_SUCCESS,
  GET_PRESCRIPTION_LIST_ERROR,
  GET_PRESCRIPTION_LIST_RESET,

  // For Admin Panel
  GET_PRESCRIPTION,
  GET_PRESCRIPTION_SUCCESS,
  GET_PRESCRIPTION_ERROR,
  GET_PRESCRIPTION_RESET,

  // For Admin Panel
  CREATE_PRESCRIPTION,
  CREATE_PRESCRIPTION_SUCCESS,
  CREATE_PRESCRIPTION_ERROR,
  CREATE_PRESCRIPTION_RESET,

  // For Admin Panel
  UPDATE_PRESCRIPTION,
  UPDATE_PRESCRIPTION_SUCCESS,
  UPDATE_PRESCRIPTION_ERROR,
  UPDATE_PRESCRIPTION_RESET,

  // For Admin Panel
  DELETE_PRESCRIPTION,
  DELETE_PRESCRIPTION_SUCCESS,
  DELETE_PRESCRIPTION_ERROR,
  DELETE_PRESCRIPTION_RESET,

  // For Admin Panel
  UPDATE_PRESCRIPTION_STATUS,
  UPDATE_PRESCRIPTION_STATUS_SUCCESS,
  UPDATE_PRESCRIPTION_STATUS_ERROR,
  UPDATE_PRESCRIPTION_STATUS_RESET,

  // For Admin Panel
  ADD_PRESCRIPTION_VALIDITY,
  ADD_PRESCRIPTION_VALIDITY_SUCCESS,
  ADD_PRESCRIPTION_VALIDITY_ERROR,
  ADD_PRESCRIPTION_VALIDITY_RESET,

  POST_DOCTOR_PRESCRIPTION_SEARCH_DATA,
  POST_DOCTOR_PRESCRIPTION_SEARCH_DATA_SUCCESS,
  POST_DOCTOR_PRESCRIPTION_SEARCH_DATA_ERROR,
  POST_DOCTOR_PRESCRIPTION_SEARCH_DATA_RESET,
  POST_DOCTOR_PRESCRIPTION_DATA,
  POST_DOCTOR_PRESCRIPTION_DATA_SUCCESS,
  POST_DOCTOR_PRESCRIPTION_DATA_ERROR,
  POST_DOCTOR_PRESCRIPTION_DATA_RESET,
  GET_PATIENT_PRESCRIPTION_DATA,
  GET_PATIENT_PRESCRIPTION_DATA_SUCCESS,
  GET_PATIENT_PRESCRIPTION_DATA_ERROR,
  GET_PATIENT_PRESCRIPTION_DATA_RESET,

  GET_MD_PRESCRIPTION_NEW_LINK,
  GET_MD_PRESCRIPTION_NEW_LINK_SUCCESS,
  GET_MD_PRESCRIPTION_NEW_LINK_ERROR,
  GET_MD_PRESCRIPTION_NEW_LINK_RESET,

  POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA,
  POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA_SUCCESS,
  POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA_ERROR,
  POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA_RESET,

  POST_FOR_PRESCRIPTION_NOTIFICATION,
  POST_FOR_PRESCRIPTION_NOTIFICATION_SUCCESS,
  POST_FOR_PRESCRIPTION_NOTIFICATION_ERROR,
  POST_FOR_PRESCRIPTION_NOTIFICATION_RESET,
} = require('./constants')

// For Admin Panel
const getPrescriptionList = ({
  take, skip, doctorId, patientId, all, download, search, status, id, from, to, date,
}) => createAction(GET_PRESCRIPTION_LIST, {
  take, skip, doctorId, patientId, all, download, search, status, id, from, to, date,
})
const getPrescriptionListSuccess = data => createAction(GET_PRESCRIPTION_LIST_SUCCESS, { data })
const getPrescriptionListError = error => createAction(GET_PRESCRIPTION_LIST_ERROR, { error })
const getPrescriptionListReset = () => createAction(GET_PRESCRIPTION_LIST_RESET)

// For Admin Panel
const getPrescription = id => createAction(GET_PRESCRIPTION, { id })
const getPrescriptionSuccess = data => createAction(GET_PRESCRIPTION_SUCCESS, { data })
const getPrescriptionError = error => createAction(GET_PRESCRIPTION_ERROR, { error })
const getPrescriptionReset = () => createAction(GET_PRESCRIPTION_RESET)

// For Admin Panel
const createPrescription = prescriptionData => createAction(CREATE_PRESCRIPTION, { prescriptionData })
const createPrescriptionSuccess = data => createAction(CREATE_PRESCRIPTION_SUCCESS, { data })
const createPrescriptionError = error => createAction(CREATE_PRESCRIPTION_ERROR, { error })
const createPrescriptionReset = () => createAction(CREATE_PRESCRIPTION_RESET)

// For Admin Panel
const updatePrescription = ({ id, prescriptionData }) => createAction(UPDATE_PRESCRIPTION, { id, prescriptionData })
const updatePrescriptionSuccess = data => createAction(UPDATE_PRESCRIPTION_SUCCESS, { data })
const updatePrescriptionError = error => createAction(UPDATE_PRESCRIPTION_ERROR, { error })
const updatePrescriptionReset = () => createAction(UPDATE_PRESCRIPTION_RESET)

// For Admin Panel
const deletePrescription = ({ id }) => createAction(DELETE_PRESCRIPTION, { id })
const deletePrescriptionSuccess = data => createAction(DELETE_PRESCRIPTION_SUCCESS, { data })
const deletePrescriptionError = error => createAction(DELETE_PRESCRIPTION_ERROR, { error })
const deletePrescriptionReset = () => createAction(DELETE_PRESCRIPTION_RESET)

// For Admin Panel
const updatePrescriptionStatus = ({ id, statusData }) => createAction(UPDATE_PRESCRIPTION_STATUS, { id, statusData })
const updatePrescriptionStatusSuccess = data => createAction(UPDATE_PRESCRIPTION_STATUS_SUCCESS, { data })
const updatePrescriptionStatusError = error => createAction(UPDATE_PRESCRIPTION_STATUS_ERROR, { error })
const updatePrescriptionStatusReset = () => createAction(UPDATE_PRESCRIPTION_STATUS_RESET)

// For Admin Panel
const addPrescriptionValidity = ({ id, date }) => createAction(ADD_PRESCRIPTION_VALIDITY, { id, date })
const addPrescriptionValiditySuccess = data => createAction(ADD_PRESCRIPTION_VALIDITY_SUCCESS, { data })
const addPrescriptionValidityError = error => createAction(ADD_PRESCRIPTION_VALIDITY_ERROR, { error })
const addPrescriptionValidityReset = () => createAction(ADD_PRESCRIPTION_VALIDITY_RESET)

const postDoctorPrescriptionSearchValue = data => createAction(POST_DOCTOR_PRESCRIPTION_SEARCH_DATA, { data })
const postDoctorPrescriptionSearchValueSuccess = data => createAction(POST_DOCTOR_PRESCRIPTION_SEARCH_DATA_SUCCESS, { data })
const postDoctorPrescriptionSearchValueError = error => createAction(POST_DOCTOR_PRESCRIPTION_SEARCH_DATA_ERROR, { error })
const postDoctorPrescriptionSearchValueReset = () => createAction(POST_DOCTOR_PRESCRIPTION_SEARCH_DATA_RESET)

const postDoctorPrescriptionData = ({ data, id }) => createAction(POST_DOCTOR_PRESCRIPTION_DATA, { data, id })
const postDoctorPrescriptionDataSuccess = data => createAction(POST_DOCTOR_PRESCRIPTION_DATA_SUCCESS, { data })
const postDoctorPrescriptionDataError = error => createAction(POST_DOCTOR_PRESCRIPTION_DATA_ERROR, { error })
const postDoctorPrescriptionDataReset = () => createAction(POST_DOCTOR_PRESCRIPTION_DATA_RESET)

const getPatientPrescriptionData = id => createAction(GET_PATIENT_PRESCRIPTION_DATA, { id })
const getPatientPrescriptionDataSuccess = data => createAction(GET_PATIENT_PRESCRIPTION_DATA_SUCCESS, { data })
const getPatientPrescriptionDataError = error => createAction(GET_PATIENT_PRESCRIPTION_DATA_ERROR, { error })
const getPatientPrescriptionDataReset = () => createAction(GET_PATIENT_PRESCRIPTION_DATA_RESET)

const getMDPrescriptionNewLink = ({ doctorId, id }) => createAction(GET_MD_PRESCRIPTION_NEW_LINK, { doctorId, id })
const getMDPrescriptionNewLinkSuccess = data => createAction(GET_MD_PRESCRIPTION_NEW_LINK_SUCCESS, { data })
const getMDPrescriptionNewLinkError = error => createAction(GET_MD_PRESCRIPTION_NEW_LINK_ERROR, { error })
const getMDPrescriptionNewLinkReset = () => createAction(GET_MD_PRESCRIPTION_NEW_LINK_RESET)

const postDoctorEditPrescriptionSearchValue = data => createAction(POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA, { data })
const postDoctorEditPrescriptionSearchValueSuccess = data => createAction(POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA_SUCCESS, { data })
const postDoctorEditPrescriptionSearchValueError = error => createAction(POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA_ERROR, { error })
const postDoctorEditPrescriptionSearchValueReset = () => createAction(POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA_RESET)

const postForPrescriptionNotificationData = ({ data, id }) => createAction(POST_FOR_PRESCRIPTION_NOTIFICATION, { data, id })
const postForPrescriptionNotificationDataSuccess = data => createAction(POST_FOR_PRESCRIPTION_NOTIFICATION_SUCCESS, { data })
const postForPrescriptionNotificationDataError = error => createAction(POST_FOR_PRESCRIPTION_NOTIFICATION_ERROR, { error })
const postForPrescriptionNotificationDataReset = () => createAction(POST_FOR_PRESCRIPTION_NOTIFICATION_RESET)

module.exports = {
  // For Admin Panel
  getPrescriptionList,
  getPrescriptionListSuccess,
  getPrescriptionListError,
  getPrescriptionListReset,
  // For Admin Panel
  getPrescription,
  getPrescriptionSuccess,
  getPrescriptionError,
  getPrescriptionReset,
  // For Admin Panel
  createPrescription,
  createPrescriptionSuccess,
  createPrescriptionError,
  createPrescriptionReset,
  // For Admin Panel
  updatePrescription,
  updatePrescriptionSuccess,
  updatePrescriptionError,
  updatePrescriptionReset,
  // For Admin Panel
  deletePrescription,
  deletePrescriptionSuccess,
  deletePrescriptionError,
  deletePrescriptionReset,
  // For Admin Panel
  updatePrescriptionStatus,
  updatePrescriptionStatusSuccess,
  updatePrescriptionStatusError,
  updatePrescriptionStatusReset,
  // For Admin Panel
  addPrescriptionValidity,
  addPrescriptionValiditySuccess,
  addPrescriptionValidityError,
  addPrescriptionValidityReset,

  postDoctorPrescriptionSearchValue,
  postDoctorPrescriptionSearchValueSuccess,
  postDoctorPrescriptionSearchValueError,
  postDoctorPrescriptionSearchValueReset,
  postDoctorPrescriptionData,
  postDoctorPrescriptionDataSuccess,
  postDoctorPrescriptionDataError,
  postDoctorPrescriptionDataReset,
  getPatientPrescriptionData,
  getPatientPrescriptionDataSuccess,
  getPatientPrescriptionDataError,
  getPatientPrescriptionDataReset,
  getMDPrescriptionNewLink,
  getMDPrescriptionNewLinkSuccess,
  getMDPrescriptionNewLinkError,
  getMDPrescriptionNewLinkReset,

  postDoctorEditPrescriptionSearchValue,
  postDoctorEditPrescriptionSearchValueSuccess,
  postDoctorEditPrescriptionSearchValueError,
  postDoctorEditPrescriptionSearchValueReset,
  postForPrescriptionNotificationData,
  postForPrescriptionNotificationDataSuccess,
  postForPrescriptionNotificationDataError,
  postForPrescriptionNotificationDataReset,
}
